/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { motion } from 'motion/react';
import { styled } from 'styled-components';

import { createResponsiveSpacingStyle, ResponsiveSpacing } from '../../../utils';
import type { SpacerProps } from './types';

const Wrapper = styled(motion.div)<{
  $marginTop?: ResponsiveSpacing;
  $marginRight?: ResponsiveSpacing;
  $marginBottom?: ResponsiveSpacing;
  $marginLeft?: ResponsiveSpacing;
}>`
  ${props => props.$marginTop && `${createResponsiveSpacingStyle('margin-top', props.$marginTop)}`};
  ${props => props.$marginRight && `${createResponsiveSpacingStyle('margin-right', props.$marginRight)}`};
  ${props => props.$marginBottom && `${createResponsiveSpacingStyle('margin-bottom', props.$marginBottom)}`};
  ${props => props.$marginLeft && `${createResponsiveSpacingStyle('margin-left', props.$marginLeft)}`};
`;

export const Spacer = ({
  style,
  id,
  className,
  initial,
  animate,
  variants,
  exit,
  transition,
  role,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  children,
}: SpacerProps) => (
  <Wrapper
    style={style}
    className={className}
    initial={initial}
    animate={animate}
    variants={variants}
    exit={exit}
    transition={transition}
    role={role}
    $marginTop={marginTop}
    $marginBottom={marginBottom}
    $marginRight={marginRight}
    $marginLeft={marginLeft}
    id={id}
  >
    {children}
  </Wrapper>
);
